import { About } from './components/About'
import { Contact } from './components/Contact'
import { Experience } from './components/Experience'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { Life } from './components/Life'
import { SkipLink } from './components/SkipLink'
import { Skills } from './components/Skills'

export function App() {
  return (
    <>
      <SkipLink />
      <Header />
      {/*
        tabIndex -1 makes the skip link's target programmatically focusable, so
        the next Tab press continues from here rather than jumping back to the nav.
      */}
      <main id="main" tabIndex={-1}>
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Life />
        <Contact />
      </main>
      <Footer />
    </>
  )
}
